import React, { useState, useEffect } from "react";
import axios from "axios";
import { Card, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://sutmmgdev.codydeasoftech.in/api";

const PaymentTransactionList = () => {
  const { id: vendorId } = useParams(); // gets vendor_id from route
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendorName, setVendorName] = useState("");

  // Pagination states
  const [page, setPage] = useState(1);
  const [perPage] = useState(10); // fixed
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // Format date
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d)) return "-";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Fetch transactions
  const fetchTransactions = async (vendor_id, pageNo = 1) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const payload = {
        vendor_id: vendor_id || "",
        page: pageNo,
        per_page: perPage,
      };

      const res = await axios.post(
        `${BASE_URL}/paymentsTransactionsList`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data?.data || [];
      setTransactions(data);

      // Pagination info
      setPage(res.data.page || pageNo);
      setTotalRecords(res.data.total_records || data.length);
      setTotalPages(
        Math.ceil((res.data.total_records || data.length) / perPage)
      );

      // Set vendor name from first transaction
      if (data.length > 0) setVendorName(data[0].vendors_master_name || "");
      else setVendorName("");
    } catch (err) {
      if (handle401(err)) return;
      console.error("Transactions Fetch Error:", err);
    } finally {
      setLoading(false);
    }
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pages = [];
    const max = 5; // max pages to show
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, start + max - 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  const theadStyle = {
    padding: "5px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    backgroundColor: "#edf7fe",
    borderBottom: "1px solid black",
    textAlign: "center",
  };

  useEffect(() => {
    fetchTransactions(vendorId, 1); // fetch first page on mount
  }, [vendorId]);

  return (
    <div className="container mt-4" style={{ maxWidth: 1200 }}>
      <Card className="mb-4 border-0">
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-list"></i> Job Worker Payment Ledger Of {vendorName}
          </h5>
        </div>
      </Card>

      <Card className="border-0">
        <Table hover responsive striped>
          <thead>
            <tr>
              <th style={theadStyle}>SL</th>
              {/* <th style={theadStyle}>Vendor Type</th> */}
              <th style={theadStyle}>Vendor</th>
              <th style={theadStyle}>Item</th>
              <th style={theadStyle}>Size</th>
              <th style={theadStyle}>Type</th>
              <th style={theadStyle}>Rate /Pc</th>
              <th style={theadStyle}>Balance</th>
              <th style={theadStyle}>Date</th>
                            <th style={theadStyle}>Job</th>

            </tr>
          </thead>
          <tbody>
            {!loading && transactions.length > 0 ? (
              transactions.map((t, index) => (
                <tr key={t.id} className="text-center">
                  <td>{(page - 1) * perPage + index + 1}</td>
                  {/* <td>{t.vendor_type_short_name}</td> */}
                  <td>{t.vendors_master_name}</td>
                  <td>{t.item_name}</td>
                  <td>{t.size}</td>
                                    <td>{t.type}</td>

                  <th>₹ {t.amount}</th>

                  <td style={{ color: "green", fontWeight: 600 }}>
                    ₹ {t.current_amount}
                  </td>
                  <td>{formatDate(t.created_at)}</td>
                  <td>{t.action_name}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  {loading ? "Loading..." : "No Data Found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-4">
            <ul className="pagination">
              {/* Prev */}
              <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchTransactions(vendorId, page - 1)}>
                  ‹
                </button>
              </li>

              {/* Page Numbers */}
              {getPageNumbers().map((p) => (
                <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                  <button className="page-link" onClick={() => fetchTransactions(vendorId, p)}>
                    {p}
                  </button>
                </li>
              ))}

              {/* Next */}
              <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
                <button className="page-link" onClick={() => fetchTransactions(vendorId, page + 1)}>
                  ›
                </button>
              </li>
            </ul>
          </div>
        )}
      </Card>
    </div>
  );
};

export default PaymentTransactionList;
